/* NomadNoodler cart upsell — reads current Shopify cart, finds any
   NN-GUIDE-{XX} line, fetches capital-city upsell data from noodlepants,
   and injects a checkbox that adds the city product to the cart when ticked.

   The $1 discount is applied by a native Shopify automatic discount
   ("Capital city guide -$1") — this script does NOT manipulate prices. */
(function () {
  "use strict";
  var root = document.getElementById("nn-upsell-root");
  if (!root || root.dataset.nnHydrated) return;
  root.dataset.nnHydrated = "1";

  var ENDPOINT = root.dataset.endpoint || "https://noodlepants.com/api/public/nomadnoodler/upsell";

  function fmt(n) {
    try { return "$" + Number(n).toFixed(2); } catch (e) { return "$" + n; }
  }

  function extractCountryCode(sku) {
    if (!sku) return null;
    var m = /^NN-GUIDE-([A-Z]{2})$/i.exec(String(sku).trim());
    return m ? m[1].toLowerCase() : null;
  }

  function hasCitySku(items, citySku) {
    var needle = String(citySku).toLowerCase();
    return items.some(function (li) { return String(li.sku || "").toLowerCase() === needle; });
  }

  function getCart() {
    return fetch("/cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); });
  }

  function findCountryLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var code = extractCountryCode(cart.items[i].sku);
      if (code) return { code: code, item: cart.items[i] };
    }
    return null;
  }

  function fetchOffer(code) {
    return fetch(ENDPOINT + "/" + encodeURIComponent(code)).then(function (r) { return r.json(); });
  }

  function fetchCityVariant(handle) {
    return fetch("/products/" + encodeURIComponent(handle) + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function addToCart(variantId) {
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    }).then(function (r) { return r.json(); });
  }

  function refreshCartDrawer() {
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    document.dispatchEvent(new CustomEvent("cart:updated"));
    if (window.theme && typeof window.theme.cart === "object" && typeof window.theme.cart.refresh === "function") {
      try { window.theme.cart.refresh(); } catch (e) { /* noop */ }
    }
  }

  function render(offer) {
    var wrap = document.createElement("div");
    wrap.className = "nn-upsell";
    wrap.setAttribute("role", "region");
    wrap.setAttribute("aria-label", "Capital city guide upsell");
    wrap.style.cssText =
      "margin:16px 0;padding:14px 16px;border:1px solid #E8DFD3;border-radius:12px;" +
      "background:#FDF8F3;font-family:inherit;color:#1a1a1a;";
    wrap.innerHTML =
      '<label style="display:flex;gap:12px;align-items:flex-start;cursor:pointer;font-size:14px;line-height:1.4;">' +
        '<input type="checkbox" data-nn-upsell-check style="margin-top:3px;flex:0 0 auto;width:16px;height:16px;accent-color:#E86A2E;">' +
        '<span style="flex:1;">' +
          '<strong style="display:block;font-size:15px;margin-bottom:2px;">Add the ' +
            offer.cityName + ' deep-dive — ' + fmt(offer.upsellPrice) +
          '</strong>' +
          '<span style="color:#5a5346;">Save ' + fmt(offer.savingsAmount) +
          ' vs. the ' + fmt(offer.listPrice) + ' standalone price. ' +
          '25+ pages of neighbourhood breakdowns, rent by area, coworking, visa notes.</span>' +
        '</span>' +
      '</label>' +
      '<div data-nn-upsell-status aria-live="polite" style="margin-top:8px;font-size:13px;color:#8a8271;display:none;"></div>';
    return wrap;
  }

  function boot() {
    getCart().then(function (cart) {
      if (!cart || !Array.isArray(cart.items) || !cart.items.length) return;
      var country = findCountryLine(cart);
      if (!country) return;

      fetchOffer(country.code).then(function (offer) {
        if (!offer || !offer.available) return;
        if (hasCitySku(cart.items, offer.citySku)) return; // already in cart

        var node = render(offer);
        root.appendChild(node);
        var status = node.querySelector("[data-nn-upsell-status]");
        var check = node.querySelector("[data-nn-upsell-check]");

        check.addEventListener("change", function () {
          if (!check.checked) return;
          check.disabled = true;
          status.style.display = "block";
          status.textContent = "Adding " + offer.cityName + "…";

          fetchCityVariant(offer.cityHandle).then(function (product) {
            var variantId = product && product.variants && product.variants[0] && product.variants[0].id;
            if (!variantId) {
              status.textContent = "Sorry, couldn't add that. Please try again.";
              check.disabled = false;
              check.checked = false;
              return;
            }
            addToCart(variantId).then(function (res) {
              if (res && res.status && res.status >= 400) {
                status.textContent = res.description || "Sorry, couldn't add that.";
                check.disabled = false;
                check.checked = false;
                return;
              }
              status.textContent = "Added! Discount applied at checkout.";
              refreshCartDrawer();
            });
          });
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // Re-run when the cart drawer re-opens (theme fires these on most themes).
  ["cart:refresh", "cart:updated", "cart:open"].forEach(function (ev) {
    document.addEventListener(ev, function () {
      // Reset root so a new offer can render for a changed cart
      root.innerHTML = "";
      delete root.dataset.nnHydrated;
      root.dataset.nnHydrated = "1";
      boot();
    });
  });
})();
